import React from 'react'
import Wrapper from '../../helpers/Wrapper'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../helpers/Axios';

function SmallHeader() {

    const { data } = useQuery({
        queryKey: ['our-store'],
        queryFn: async () => {
            const res = await apiClient.get('/shop/small-header');
            return res.data
        }
    })


    return (
        <div className='bg-[#121212] text-white py-2.5 hidden lg:block'>
            <Wrapper>
                <div className="flex justify-between items-center">
                    {/* 1st One */}
                    <div>
                        <div className="flex items-center gap-1">
                            <p className="text-[clamp(0.85rem,2vw+1rem,1rem)] text-[rgb(153,153,153)]">{data?.title}: </p>
                            <Link className='text-[15px] underline' to={data?.link_url}>{data?.link_name}</Link>
                        </div>
                    </div>
                    {/* 2nd One */}
                    <div>
                        <Link
                            className='text-[rgb(153,153,153)] tracking-wide text-sm hover:text-white transition' to={'/pages/our-store'}>
                            Our Stores
                        </Link>
                    </div>
                </div>
            </Wrapper>
        </div>
    )
}

export default SmallHeader